<template>
    <template v-if="modalReady">
        <Teleport to="#outsideMain">
            <span class="modal-navigation">
                <a v-if="navigationList.length > 0" class="modal-navigation__link" @click="activateModal()">{{ buttonText }}</a>
                <a v-if="showContactForm" class="modal-navigation__link modal-navigation__link--btn" @click="activateContactModal()">
                    {{ translationsStore.getTranslation('Translate.ModalNavigation.Contact').Value }}
                    <span class="modal-navigation__link-icon">
                        <svg id="uuid-914762ef-1ede-4eb2-a46b-76b16e07c45f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 20"><path d="m25,0H1C.448,0,0,.448,0,1v17c0,1.105.895,2,2,2h22c1.105,0,2-.895,2-2V1c0-.552-.448-1-1-1Zm-2.571,2l-9.429,8.644L3.571,2h18.858Zm1.571,16H2V3.274l10.324,9.464c.382.351.97.351,1.353,0L24,3.274v14.726Z" /></svg>
                    </span>
                </a>
            </span>
        </Teleport>
    </template>
    <template v-if="modalReady && modalActive">
        <Teleport to="#modal">
            <div :id="modalId" class="modal">
                <div class="modal__content modal__content--with-navigation">
                    <nav class="modal__navigation">
                        <ul ref="modalNavigationList" class="modal__navigation-list">
                            <li v-for="navigationItem in navigationItems" :key="navigationItem.ID" class="modal__navigation-item">
                                <a :href="navigationItem.PropertyItem.Link" :class="(['modal__navigation-link', activePageId == navigationItem.ID ? 'modal__navigation-link--active' : null])" @click.stop.prevent="loadPageContent(navigationItem.ID, true)">{{ navigationItem.Name }}</a>
                            </li>
                        </ul>
                    </nav>
                    <template v-if="paragraphs !== null">
                        <div class="modal__content-inner">
                            <template v-for="item in paragraphs" :key="item.ID">
                                <paragraph-item class="modal__module" :item="item" :modal-has-navigation="true"></paragraph-item>
                            </template>
                        </div>
                    </template>
                    <span class="modal__close" @click="deactivateModal()">
                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.1948 7.03569L14.4683 2.97569C14.6335 2.84159 14.7678 2.67641 14.8628 2.49053C14.9578 2.30465 15.0114 2.10207 15.0203 1.89552C15.0292 1.68896 14.9931 1.48289 14.9144 1.29023C14.8357 1.09757 14.7161 0.922481 14.5629 0.775957C14.4098 0.629432 14.2265 0.514635 14.0246 0.438768C13.8227 0.362901 13.6065 0.327604 13.3896 0.335091C13.1727 0.342578 12.9597 0.392687 12.7641 0.482275C12.5685 0.571863 12.3944 0.698994 12.2528 0.85569L7.9688 4.91569L3.7058 0.84569C3.56161 0.698316 3.38773 0.580112 3.19453 0.498128C3.00133 0.416144 2.79278 0.37206 2.5813 0.368507C2.36982 0.364953 2.15976 0.402003 1.96365 0.477445C1.76753 0.552887 1.58938 0.665176 1.43982 0.807613C1.29026 0.950051 1.17236 1.11972 1.09315 1.30649C1.01393 1.49327 0.975029 1.69333 0.978761 1.89473C0.982492 2.09614 1.02878 2.29477 1.11486 2.47877C1.20095 2.66277 1.32506 2.82837 1.4798 2.96569L5.7428 7.03569L1.4693 11.0957C1.17436 11.3769 1.00869 11.7582 1.00869 12.1557C1.00869 12.5532 1.17436 12.9344 1.4693 13.2157C1.76641 13.4972 2.16846 13.6552 2.58755 13.6552C3.00665 13.6552 3.4087 13.4972 3.7058 13.2157L7.9688 9.15569L12.2318 13.2257C12.3761 13.3673 12.5493 13.4794 12.7406 13.555C12.932 13.6307 13.1376 13.6683 13.3448 13.6657C13.6561 13.6654 13.9603 13.5773 14.2191 13.4125C14.4779 13.2476 14.6795 13.0135 14.7986 12.7395C14.9177 12.4656 14.9489 12.1642 14.8882 11.8734C14.8276 11.5826 14.6778 11.3155 14.4578 11.1057L10.1948 7.03569Z" />
                        </svg>
                        <span class="modal__close-text">{{ translationsStore.getTranslation('Translate.Modal.Close').Value }}</span>
                    </span>
                </div>
            </div>
        </Teleport>
    </template>
    <template v-if="showContactForm && contactModalActive">
        <Teleport to="#modal">
            <div :id="(`contact-${modalId}`)" class="modal">
                <div class="modal__content">
                    <div class="modal__content-inner">
                        <div v-if="form" class="form-module theme--white">
                            <span v-if="formHeadline !== null" class="form-module__headline">{{ formHeadline }}</span>
                            <form :id="formId" action="/ClickDimensionsFormHandler.ashx" class="form" method="post" @submit="submitForm">
                                <input type="hidden" name="formURL" :value="(`https://analytics-eu.clickdimensions.com/forms/h/${form.FormId}`)" />
                                <input type="hidden" name="successURL" :value="(`https://${domain}/${successUrl}`)" />
                                <input type="hidden" name="errorURL" :value="(`https://${domain}/${errorUrl}`)" />
                                <input v-if="cuvid !== null" type="hidden" name="cd_visitorkey" :value="cuvid" />
                                <input id="url" type="hidden" name="url" :value="pageUrl" />
                                <input id="context" type="hidden" name="context" :value="form.Context" />
                                <input v-if="productName !== null && productNumber !== null" id="product" type="hidden" name="product" :value="(`${productNumber} - ${productName}`)">
                                <input v-if="recaptchaToken !== null" :id="(`recaptchaToken-${formId}`)" type="hidden" name="recaptchaToken" :value="recaptchaToken" />
                                <input type="hidden" name="recaptchaAction" :value="form.Context" />
                                <template v-for="(field, index) in form.Fields" :key="index">
                                    <div
                                        v-if="(field.FieldName != 'company' || field.FieldName == 'company' && customerType != 'private')"
                                        class="form__field-wrap"
                                        :class="(`form__field-wrap--${field.FieldName.toLowerCase()} form__field-wrap--${field.FieldType.SelectedName.toLowerCase()}`)"
                                    >
                                        <input
                                            v-if="(['Text','Tel','Email'].includes(field.FieldType.SelectedName))"
                                            :id="(`${field.FieldName}-${paragraphId}`)"
                                            class="form__field"
                                            :class="(`form__field--${field.FieldName.toLowerCase()} form__field--${field.FieldType.SelectedName.toLowerCase()}`)"
                                            :placeholder="field.FieldLabel"
                                            :type="field.FieldType.SelectedName.toLowerCase()"
                                            :name="field.FieldName"
                                            required
                                        />
                                        <textarea
                                            v-else-if="field.FieldType.SelectedName == 'Textarea'"
                                            :id="(`${field.FieldName}-${paragraphId}`)"
                                            class="form__field"
                                            :placeholder="field.FieldLabel"
                                            :class="(`form__field--${field.FieldName.toLowerCase()} form__field--${field.FieldType.SelectedName.toLowerCase()}`)"
                                            :name="field.FieldName"
                                            required
                                        ></textarea>
                                        <select
                                            v-else-if="field.FieldType.SelectedName == 'Select'"
                                            :id="(`${field.FieldName}-${paragraphId}`)"
                                            class="form__field"
                                            :class="(`form__field--${field.FieldName.toLowerCase()} form__field--${field.FieldType.SelectedName.toLowerCase()}`)"
                                            :name="field.FieldName"
                                            required
                                            @change="changeSelect($event)"
                                        >
                                            <option value="" disabled selected>{{ field.DefaultOptionText }}</option>
                                            <option v-for="(option, optionIndex) in field.FieldOptions" :key="optionIndex" :value="option.Value">{{ option.Label }}</option>
                                        </select>
                                        <label v-if="(['Text','Tel','Email'].includes(field.FieldType.SelectedName) || field.FieldType.SelectedName == 'Textarea')" class="form__label" :class="(`form__label--${field.FieldType.SelectedName.toLowerCase()}`)" :for="(`${field.FieldName}-${paragraphId}`)">{{ field.FieldLabel }}</label>
                                    </div>
                                </template>
                                <div class="form__field-wrap form__field-wrap--consent">
                                    <input :id="(`consent-${paragraphId}`)" class="form__field form__field--checkbox" type="checkbox" name="consent" value="true" required />
                                    <label :for="(`consent-${paragraphId}`)" class="form__label form__label--checkbox" v-html="consent"></label>
                                </div>
                                <div class="form__field-wrap form__field-wrap--submit">
                                    <button type="submit" class="btn btn--primary">
                                        <span class="btn__text">{{ submitText }}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <span class="modal__close" @click="deactivateContactModal()">
                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.1948 7.03569L14.4683 2.97569C14.6335 2.84159 14.7678 2.67641 14.8628 2.49053C14.9578 2.30465 15.0114 2.10207 15.0203 1.89552C15.0292 1.68896 14.9931 1.48289 14.9144 1.29023C14.8357 1.09757 14.7161 0.922481 14.5629 0.775957C14.4098 0.629432 14.2265 0.514635 14.0246 0.438768C13.8227 0.362901 13.6065 0.327604 13.3896 0.335091C13.1727 0.342578 12.9597 0.392687 12.7641 0.482275C12.5685 0.571863 12.3944 0.698994 12.2528 0.85569L7.9688 4.91569L3.7058 0.84569C3.56161 0.698316 3.38773 0.580112 3.19453 0.498128C3.00133 0.416144 2.79278 0.37206 2.5813 0.368507C2.36982 0.364953 2.15976 0.402003 1.96365 0.477445C1.76753 0.552887 1.58938 0.665176 1.43982 0.807613C1.29026 0.950051 1.17236 1.11972 1.09315 1.30649C1.01393 1.49327 0.975029 1.69333 0.978761 1.89473C0.982492 2.09614 1.02878 2.29477 1.11486 2.47877C1.20095 2.66277 1.32506 2.82837 1.4798 2.96569L5.7428 7.03569L1.4693 11.0957C1.17436 11.3769 1.00869 11.7582 1.00869 12.1557C1.00869 12.5532 1.17436 12.9344 1.4693 13.2157C1.76641 13.4972 2.16846 13.6552 2.58755 13.6552C3.00665 13.6552 3.4087 13.4972 3.7058 13.2157L7.9688 9.15569L12.2318 13.2257C12.3761 13.3673 12.5493 13.4794 12.7406 13.555C12.932 13.6307 13.1376 13.6683 13.3448 13.6657C13.6561 13.6654 13.9603 13.5773 14.2191 13.4125C14.4779 13.2476 14.6795 13.0135 14.7986 12.7395C14.9177 12.4656 14.9489 12.1642 14.8882 11.8734C14.8276 11.5826 14.6778 11.3155 14.4578 11.1057L10.1948 7.03569Z" />
                        </svg>
                        <span class="modal__close-text">{{ translationsStore.getTranslation('Translate.Modal.Close').Value }}</span>
                    </span>
                </div>
            </div>
        </Teleport>
    </template>
</template>
<script>
import ParagraphItem from './paragraph-item.vue';
import { useContentStore, useTranslationsStore } from '../store';
import { useItem } from '../composables/item';
import { getCurrentInstance } from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
const { mapItems } = useItem();

export default {
    name: 'ModalNavigation',
    components: {
        ParagraphItem
    },
    props: {
        paragraphId: {
            type: Number,
            default: 0
        },
        modalId: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: null
        },
        showContactForm: {
            type: Boolean,
            default: false
        },
        navigationList: {
            type: Array,
            default: () => []
        },
        formHeadline: {
            type: String,
            default: null
        },
        formId: {
            type: Number,
            default: 0
        },
        successUrl: {
            type: String,
            default: ''
        },
        errorUrl: {
            type: String,
            default: ''
        },
        submitButtonText: {
            type: String,
            default: null,
        },
        consentText: {
            type: String,
            default: null
        },
        cuvid: {
            type: String,
            default: null
        },
        productName: {
            type: String,
            default: null
        },
        productNumber: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            pageUrl: window.location.href,
            domain: window.location.hostname,
            modalReady: false,
            modalActive: false,
            contactModalActive: false,
            translationsStore: null,
            contentStore: null,
            paragraphs: null,
            form: null,
            activePageId: null,
            reCaptcha: null,
            recaptchaToken: null,
            customerType: 'private',
        };
    },
    computed: {
        navigationItems() {
            return this.navigationList.map(item => ({
                pages: item.Type == 'sub-pages' ? this.contentStore.pages.filter(x => x.Path.find(y => y.ID == item.Link) !== undefined) : [this.contentStore.pages.find(x => x.ID == item.Link)]
            })).flatMap(item => item.pages);
        },
        submitText() {
            return this.submitButtonText !== null ? this.submitButtonText : this.translationsStore.getTranslation('Translate.Form.Send').Value;
        },
        consent() {
            return this.consentText !== null ? this.consentText : this.translationsStore.getTranslation('Translate.Form.Consent').Value;
        }
    },
    mounted() {
        const app = getCurrentInstance();
        app.appContext.app.use(VueReCaptcha, { siteKey: '6LdN1l4aAAAAAOnA0DRJAalB_Y3q1E4W0fCzU9Q0' });

        this.translationsStore = useTranslationsStore();
        this.contentStore = useContentStore();

        const fetches = this.navigationList.map(item => item.Type == 'sub-pages' ? this.contentStore.fetchPages(item.Link) : this.contentStore.fetchPage(item.Link));
        fetches.push(this.translationsStore.fetchTranslations());

        if (this.formId != 0) {
            fetches.push(this.contentStore.fetchParagraph(this.formId));
        }

        Promise.all(fetches).then(() => {
            this.modalReady = true;

            if (this.formId != 0) {
                this.form = mapItems([this.contentStore.getParagraph(this.formId)])[0];
            }

            if (this.navigationItems.length > 0 || window.location.hash.includes('page')) {
                const pageId = window.location.hash.includes('page=') ? window.location.hash.split('page=')[1].replace('page','') : this.navigationItems[0].ID;

                setTimeout(() => {
                    this.loadPageContent(pageId, (pageId != this.navigationItems[0].ID));

                    if (pageId != this.navigationItems[0].ID || window.location.hash.includes(this.modalId)) {
                        if (window.location.hash.includes(`contact-${this.modalId}`)) {
                            this.activateContactModal();
                        } else {
                            this.activateModal();
                        }
                    }
                },10);
            }
        });
    },
    methods: {
        async submitForm(e) {
            e.preventDefault();

            await this.$recaptchaLoaded();
            this.recaptchaToken = await this.$recaptcha(this.form.Context);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'formSubmission',
                'formType': 'Product question',
                'formName': this.productNumber,
                'eventCallback': () => {
                    e.target.submit();
                },
                'eventTimeout' : 2000
            });

            setTimeout(function() {
                e.target.submit();
            },10);
        },
        activateModal() {
            this.modalActive = true;
            history.pushState({}, document.title, `#modal=${this.modalId}`);

            const _this = this;

            setTimeout(() => {
                _this.addEvents();
            }, 10);
        },
        deactivateModal() {
            this.removeEvents();
            this.modalActive = false;
            this.resetHash();
        },
        activateContactModal() {
            this.contactModalActive = true;
            history.pushState({}, document.title, `#modal=contact-${this.modalId}`);

            const _this = this;

            setTimeout(() => {
                _this.addEvents();
            }, 10);
        },
        deactivateContactModal() {
            this.removeEvents();
            this.contactModalActive = false;
            this.resetHash();
        },
        resetHash() {
            history.pushState({}, document.title, window.location.pathname);
        },
        loadPageContent(pageId, updateUrl = false) {
            if (this.activePageId != pageId) {
                this.activePageId = pageId;
                const fetches = [this.contentStore.fetchParagraphs(pageId)];

                if (this.$refs.modalNavigationList !== undefined) {
                    this.$refs.modalNavigationList.classList.remove('modal__navigation-list--open');
                }

                Promise.all(fetches).then(() => {
                    this.paragraphs = mapItems(this.contentStore.getParagraphs(pageId));
                });

                if (updateUrl) {
                    history.pushState({}, document.title, `#modal=${this.modalId}&page=${pageId}`);
                }
            } else {
                this.$refs.modalNavigationList.classList.contains('modal__navigation-list--open') ? this.$refs.modalNavigationList.classList.remove('modal__navigation-list--open') : this.$refs.modalNavigationList.classList.add('modal__navigation-list--open');
            }
        },
        changeSelect(e) {
            this.customerType = e.target.name == 'customer-type' ? e.target.value : 'private';
        },
        keyUpEvent(e) {
            if (e.key === 'Escape' && (this.modalActive || this.contactModalActive)) {
                if (this.modalActive) {
                    this.deactivateModal();
                }

                if (this.contactModalActive) {
                    this.deactivateContactModal();
                }
            }
        },
        clickEvent(e) {
            const modalContent = e.target.closest('.modal__content');

            if (this.modalActive && modalContent === null) {
                this.deactivateModal();
            }

            if (this.contactModalActive && modalContent === null) {
                this.deactivateContactModal();
            }
        },
        addEvents() {
            window.addEventListener('keyup', this.keyUpEvent);
            window.addEventListener('click', this.clickEvent);
        },
        removeEvents() {
            window.removeEventListener('keyup', this.keyUpEvent);
            window.removeEventListener('click', this.clickEvent);
        }
    }
};
</script>
